<template>
    <v-card>
        <v-toolbar color="primary" class="white--text">
            <v-toolbar-title>Product Groups</v-toolbar-title>
        </v-toolbar>
        <v-layout wrap>
            <v-flex xs12 sm3 offset-sm1>
                <v-text-field 
                    :value="search" 
                    @input="handleSearch" 
                    append-icon="search" 
                    label="Filter" 
                    single-line 
                    hide-details>
                </v-text-field>
            </v-flex>
            <v-flex xs12 sm3 offset-sm1>
                <v-checkbox 
                    class="active-checkbox" 
                    label="Active Only" 
                    :value="activeOnly" 
                    @change="handleActiveOnly" 
                    hide-details>
                </v-checkbox>
            </v-flex>
            <v-flex xs12 sm2 offset-sm1>
                <v-btn 
                    color="primary" 
                    block 
                    @click="openAdd()">
                    <span>Add</span>
                </v-btn>
            </v-flex>
        </v-layout>
        <v-layout pt-3>
            <v-flex xs12>
                <v-data-table
                    :headers="headers"
                    :rows-per-page-items="rowsPerPageItems"
                    :pagination.sync="pagination"
                    :items="filteredItems">
                    <template v-slot:items="{ item }">
                        <td>{{ item.productCategory }}</td>
                        <td>{{ item.productGroupName }}</td>
                        <td>{{ item.description }}</td>
                        <td>{{ item.isActive ? 'Active' : 'Inactive' }}</td>
                        <td>
                            <v-btn 
                                color="primary"
                                block 
                                @click="openEdit(item.originalIndex)">
                                <span>Edit</span>
                            </v-btn>
                        </td>
                    </template>
                </v-data-table>
            </v-flex>
        </v-layout>
    </v-card>
</template>

<script>
export default {
    props: {
        data: {
            required: true,
            value: Array
        }
    },
    data(){
        return {
            search: null,
            activeOnly: false,
            items: [],
            filteredItems: [],
            headers: [
                {
                    text: "Product Category",
                    value: "productCategory",
                    sortable: true
                }, 
                {
                    text: "Product Group Name",
                    value: "productGroupName",
                    sortable: true
                },
                {
                    text: "Description",
                    value: "description",
                    sortable: true
                },
                {
                    text: "Active",
                    value: "isActive",
                    sortable: true
                },
                {
                    text: "Edit",
                    value: "originalIndex"
                }
            ],
            pagination: {
                page: 1,
                rowsPerPage: 25,
                descending: false
            },
            rowsPerPageItems: [10, 25, 50, 100],
        }
    },
    watch: {
        data(){
            this.updateItems();
        }
    },
    created(){
        this.updateItems();
    },
    methods: {
        updateItems(){
            this.items = this.createItems(this.data);
            this.updateFilteredItems();
        },
        createItems(data){
            return data.map((x, i) => {
                return {
                    originalIndex: i,
                    productCategory: x.ProductCategoryName,
                    productGroupName: x.ProductGroupName,
                    description: x.Description,
                    isActive: x.IsActive
                }
            });
        },
        handleActiveOnly(newActiveOnly){
            if(newActiveOnly == null){
                newActiveOnly = false;
            }
            this.activeOnly = newActiveOnly;
            this.updateFilteredItems();
        },
        handleSearch(newSearch){
            if(newSearch == ""){
                newSearch = null;
            }
            this.search = newSearch;
            this.updateFilteredItems();
        },
        updateFilteredItems(){
            this.filteredItems = this.filterItems(this.items, this.activeOnly, this.search);
        },
        matches(a, b){
            return a != null && b != null && a.toLowerCase().includes(b.toLowerCase());
        },
        filterItems(items, activeOnly, search){
            return items.filter(x => {
                return (activeOnly == false || x.isActive == true) 
                    && (search == null 
                        || this.matches(x.productCategory, search)
                        || this.matches(x.productGroupName, search)
                        || this.matches(x.description, search)
                    );
            });
        },
        openAdd(){
            this.$emit("add");
        },
        openEdit(index){
            this.$emit("edit", index);
        }
    }
}
</script>